import React from "react"
export const FormError = () => (
  <div className="contact__error">
    <p>Er is een fout opgetreden. Probeer het opnieuw</p>
  </div>
)
